AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Report");

AoPS.Alcumus.Views.Report = (function (AlcVReport) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var AlcUrl = AoPS.Alcumus.Url;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVCat = AoPS.Alcumus.Views.Cat;

	function getPanelHeader(model) {
		if (model.model_type === "user") {
			return "All Topics";
		} else if (model.model_type === "subject") {
			return model.get("name");
		} else if (model.model_type === "class") {
			return model.get("name");
		} else if (model.model_type === "topic") {
			return model.get("name");
		} else {
			return "";
		}
	}

	function withScrollTopSaved(getEl, f, thisValue) {
		if (thisValue) {
			getEl = _.bind(getEl, thisValue);
			f = _.bind(f, thisValue);
		}
		var el = getEl();
		var scroll_top = el ? el.scrollTop() : null;
		f();
		if (scroll_top) {
			var el_now = getEl();
			el_now && el_now.scrollTop(scroll_top);
		}
	}

	// All of the main report views (ReportPage, StatsPanel, ProgressTable,
	// ProblemTable) get passed a models object, which is an object with:
	// - model: any of user/subject/class/topic, main one, always set
	// - user_model: the user model, always set
	// - cat_model: the "category" model, either a subject or class, optional
	// - topic_model: the topic model, optional

	// Top-level report view; uses models object
	// This view gets some unique handling where the router keeps it mounted on
	// the page even on URL changes within the report page. The setModels method
	// gets called after each URL change instead. This makes it possible to
	// obtain some tricky behavior with scroll positions.
	AlcVReport.ReportPage = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-report-page");
			this.setModels(options.models);
		},

		setModels: function (models) {
			this.models = models;

			var getProgressScroll = function () {
				return this.progress && this.progress.$(".aops-scroll-inner");
			};
			withScrollTopSaved(
				getProgressScroll,
				function () {
					this.createAllSubviews();
					this.render();
				},
				this
			);
		},

		computeViewIDs: function (models) {
			var spec_id = "report-" + models.user_model.id;
			if (models.cat_model) {
				spec_id += "-" + models.cat_model.model_type;
				spec_id += "-" + models.cat_model.id;
			}
			var prog_id = spec_id;
			if (models.topic_model) {
				spec_id += "-" + models.topic_model.id;
			}
			return {
				spec_id: spec_id,
				prog_id: prog_id,
			};
		},

		createAllSubviews: function () {
			var ids = this.computeViewIDs(this.models);
			var last_ids = this.last_rendered_ids || {};

			if (last_ids.spec_id !== ids.spec_id) {
				this.clearLocation("@stats");
				this.stats = new AlcVReport.StatsPanel({
					models: this.models,
				});
				this.addSubviewToLocation(this.stats, "@stats");

				this.clearLocation("@problems");
				this.problems = new AlcVReport.ProblemTable({
					models: this.models,
				});
				this.addSubviewToLocation(this.problems, "@problems");
			}

			if (last_ids.prog_id !== ids.prog_id) {
				this.clearLocation("@progress");
				this.progress = new AlcVReport.ProgressTable({
					models: this.models,
				});
				this.addSubviewToLocation(this.progress, "@progress");
			}

			this.last_rendered_ids = ids;
		},

		postRender: function () {
			var topic_model = this.models.topic_model;
			if (this.progress) {
				this.progress.setTopicModel(topic_model);
			}
		},
	});

	// Uses models object
	AlcVReport.StatsPanel = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-report-stats-panel");

			this.model = options.models.model;
			this.user_model = options.models.user_model;
			this.cat_model = options.models.cat_model;

			if (this.user_model.isLoaded()) {
				this.afterLoad(true, {});
			} else {
				this.user_model.requestLoad(this.afterLoad, this);
				this.renderLoading();
			}
		},

		// requestLoad's usual delay is bad for the page layout here, so we
		// separate out the callback as something we can call directly.
		afterLoad: function (ok, data) {
			if (!ok) {
				return this.renderError(data);
			}
			var model = this.model;
			var user_model = this.user_model;

			this.dropdown = new AlcVCat.Dropdown({model: user_model});
			this.dropdown.selectModel(this.cat_model);
			this.listenTo(this.dropdown, "select", this.onDropdownSelect);
			this.addSubviewToLocation(this.dropdown, "@dropdown_nav");

			this.listenTo(model, "change", this.render);
			if (model.has("problem_stats")) {
				this.listenTo(model.get("problem_stats"), "change", this.render);
			}

			this.render();
		},

		getContext: function () {
			var context = {};
			var model = this.model;
			var user_model = this.user_model;

			function roundTo(x, decimal_places) {
				var factor = Math.pow(10, decimal_places);
				return Math.round(x * factor) / factor;
			}

			context.header = "Report for " + user_model.get("username");

			if (model.has("problem_stats")) {
				context.problem_stats = model.get("problem_stats").toJSON();
				context.problem_stats.percent = (function (x) {
					return x >= 0 ? roundTo(x, 1) : "N/A";
				})(context.problem_stats.percent);
			}

			if (model.has("score")) {
				context.score = roundTo(model.get("score"), 1);
			}

			if (model.has("status")) {
				context.status = model.formatStatus();
			}

			return context;
		},

		onDropdownSelect: function (sel_model) {
			var user_id = this.user_model.getUrlId();
			var sel_id = sel_model.id;
			var sel_type = sel_model.model_type;

			var url;
			if (sel_type === "user") {
				url = AlcUrl.getUrl("report", user_id);
			} else if (sel_type === "class") {
				url = AlcUrl.getUrl("report_class", user_id, sel_id);
			} else if (sel_type === "subject") {
				url = AlcUrl.getUrl("report_subject", user_id, sel_id);
			}

			if (url) {
				Backbone.trigger("alc_goto_url", url);
				// Reset selection for next time we come to this page
				this.dropdown.selectModel(this.cat_model);
			}
		},
	});

	// Uses models object
	AlcVReport.ProgressTable = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-report-progress-table");

			this.user_model = options.models.user_model;
			this.cat_model = options.models.cat_model;
			this.topic_model = options.models.topic_model;
			// Main model must not be a topic model. Use the last thing in the chain
			// before the topic model instead.
			this.model = this.cat_model || this.user_model;

			this.has_rendered = false;

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.progress_table = new AlcVCat.ProgressTable({
					parent_model: this.model,
					row_models: this.getRowModels(),
					left_column_header: this.getLeftColumnHeader(),
					table_type: "report_nav",
				});
				this.addSubviewToLocation(this.progress_table, "@progress_table");

				this.render();
			}, this);
			this.renderLoading();
		},

		setTopicModel: function (model) {
			this.topic_model = model;
			if (this.progress_table) {
				this.progress_table.selectModel(model);
			}
		},

		// Use the model and its model_type to determine what rows are needed.
		getRowModels: function () {
			var model = this.model;
			if (model.model_type === "user") {
				// Main page: show all classes then all subjects
				return [].concat(
					model.get("classes").models,
					model.get("subjects").models
				);
			} else {
				// In a subject/class, display topic list
				return model.get("topics").models;
			}
		},

		getLeftColumnHeader: function () {
			if (this.model.model_type !== "user") {
				return "Topics";
			} else if (this.model.get("classes").length) {
				return "Classes and Subjects";
			} else {
				return "Subjects";
			}
		},

		getContext: function () {
			return {
				header: "Progress in " + getPanelHeader(this.model),
			};
		},

		postRender: function () {
			if (this.progress_table) {
				this.progress_table.selectModel(this.topic_model);
				if (!this.has_rendered) {
					this.progress_table.scrollToModel(this.topic_model);
				}
			}
			this.has_rendered = true;
		},
	});

	// Uses models object
	AlcVReport.ProblemTable = AlcVBase.BaseView.extend({
		// Note the bbextras subview machinery does not have enough control
		// over ordering, so it is completely unused here.

		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-report-problem-table");

			this.model = options.models.model;
			this.row_subviews = {};
			this.all_loaded = false;

			var trials = this.model.get("trials");
			trials.requestLoadStart(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.render();
				this.listenTo(trials, "trials_loaded", this.addNewRows);
				this.listenTo(trials, "new_trial reset", this.render);
			}, this);
			this.renderLoading();
		},

		resetRows: function () {
			var trials = this.model.get("trials");
			var views = trials.map(this.getOrCreateRowView, this);
			var view_els = _.pluck(views, "$el");

			var container_el = this.$(".alc--rows");
			if (views.length) {
				container_el.removeClass("alc--none").empty().append(view_els);
			} else {
				container_el
					.addClass("alc--none")
					.html("There are no problems to display.");
			}
			this.renderRowsMathJax(views);

			this.all_loaded = trials.all_loaded;
		},

		addNewRows: function () {
			var last_trial_id = _.min(_.keys(this.row_subviews));
			var trials = this.model.get("trials");

			// Determine where in the collection the last trial we've rendered is.
			// Underscore has no findIndex...
			var last_trial_index = -1;
			trials.find(function (trial, i) {
				if (trial.id === last_trial_id) {
					last_trial_index = i;
					return true;
				}
			});
			if (last_trial_index === -1) {
				// Get things back on track with a reset.
				return this.resetRows();
			}

			var views = trials
				.slice(last_trial_index + 1)
				.map(this.getOrCreateRowView, this);
			var view_els = _.pluck(views, "$el");
			this.$(".alc--rows").append(view_els);
			this.renderRowsMathJax(views);

			this.all_loaded = trials.all_loaded;
		},

		getOrCreateRowView: function (trial) {
			var subviews = this.row_subviews;
			if (!subviews[trial.id]) {
				subviews[trial.id] = new AlcVReport.ProblemTableRow({
					model: trial,
				});
			}
			return subviews[trial.id];
		},

		renderRowsMathJax: function (views) {
			// We no longer use MathJax rendering in the report table.
			return;
		},

		onLoadError: function (data) {
			var errorBoxTpl = compileTemplate("#alc-tpl-error-box");
			this.$(".alc--rows").append(
				errorBoxTpl({
					intro: "An error occurred when fetching more trials.",
					error_msg: data.error_msg || "",
					footer:
						"This might be a temporary issue. " +
						'<a class="alc-retry alc-pointer">Click here</a> ' +
						"to reboot the problem table and try what you did again.",
				})
			);

			this.$(".alc-retry").one("click", _.bind(this.render, this));
		},

		getContext: function () {
			return {
				header: "Problems in " + getPanelHeader(this.model),
				total: this.model.get("trials").total,
			};
		},

		postRender: function () {
			this.resetRows();
			AlcVBase.buildScrollbar(this.$el);

			// Loading indicator displayed when loading more rows
			var loader_row = $($.parseHTML('<div class="alc-row-loader"></div>'));
			this.$(".alc--rows").after(loader_row);
			loader_row.hide();
			loader_row.append(AoPS.Page.$loader.clone());

			this.$(".aops-scroll-bar").on(
				"slider_at_end",
				_.bind(function () {
					if (this.fetching_more || this.all_loaded) {
						return;
					}

					this.fetching_more = true;
					loader_row.show();
					this.model.get("trials").requestLoadMore(function (ok, data) {
						if (data && data.error_code === "E_AJAX_FILTERED") {
							return;
						}

						this.fetching_more = false;
						loader_row.hide();

						if (!ok) {
							this.$(".aops-scroll-bar").off("slider_at_end");
							this.onLoadError(data);
						} else if (data.all_loaded) {
							this.all_loaded = true;
						}
					}, this);
				}, this)
			);
		},
	});

	AlcVReport.ProblemTableRow = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-report-problem-table-row");

			this.listenTo(this.model, "change", this.render);

			// This view might be created with a stub model that will get filled in
			// almost immediately. Detect if this is the case with the problem_text_short
			// attribute.
			if (this.model.get("problem_text_short").length) {
				// Trial is loaded and ready to go.
				this.stopListening(this.model);
				this.render();
			} else if (this.model.get("is_invalid")) {
				// Invalid trials are also ready to render for a different reason.
				this.stopListening(this.model);
				this.render();
			} else {
				// Can't render yet, but may as well get the top level element right.
				this.renderTopOnly();
			}
		},

		getContext: function () {
			var model = this.model;

			if (!model || model.get("is_invalid")) {
				return {
					is_invalid: true,
					result: model.get("result"),
					trial_date: model.get("trial_date"),
				};
			}

			return {
				is_invalid: false,
				problem_text_short: model.get("problem_text_short"),
				result: model.get("result"),
				trial_date: model.get("trial_date"),
				trial_url: AlcUrl.getUrl(
					"report_trial",
					model.get("user").getUrlId(),
					model.id
				),
			};
		},

		postRender: function () {
			AoPS.doFastMathJax(this.$el);
		},
	});

	return AlcVReport;
})(AoPS.Alcumus.Views.Report);
